module.exports = require("rxjs/operators/tap");


//////////////////
// WEBPACK FOOTER
// external "rxjs/operators/tap"
// module id = 112
// module chunks = 0